export const DOMAIN = 'consentConfigDetails.rules';
